import React from 'react';
import classnames from 'classnames';
import { withTranslation } from 'react-i18next';
import { withMobileContext } from '@wix/da-react-context/pkg/MobileContext';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import CloseIcon from '@wix/da-ds/pkg/Icons/generated/components/CloseThin';
import s from './CloseButton.scss';
class CloseButton extends React.Component {
    render() {
        const size = this.props.size || (this.props.isMobile ? '1em' : '1.35em');
        return /*#__PURE__*/ React.createElement(PlainButtonOrLink, {
            className: classnames(s['root'], this.props.className),
            onClick: this.props.onClick
        }, /*#__PURE__*/ React.createElement(CloseIcon, {
            size: size
        }));
    }
}
export default withTranslation()(withMobileContext(CloseButton));
